import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import auth from '@/core/Auth';
import { useRoute, useRouter } from 'vue-router';
import { ErrorBag, handleFormError } from '@/core/common';
import { Flash } from '@/core/Flash';
import { Loader } from '@/core/Loader';
import { ApiError } from '@/core/http/ApiError';
import LoginLayout from '@/modules/login/components/LoginLayout.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import FaIcon from '@/core/components/FaIcon.vue';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppInput from '@/core/components/form/AppInput.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordReset',
  setup(__props) {

const { $gettext } = useGettext();
const route = useRoute();
const router = useRouter();
const errors = ref<ErrorBag>({});
const password = ref<string>('');
const repeatPassword = ref<string>('');
const selector = route.params.selector as string;
const verifier = route.params.verifier as string;

auth.getPasswordReset(selector, verifier)
	.catch(e => {
		if (e instanceof ApiError && e.response.status === 404) {
			Flash.danger($gettext('Din begäran tog får lång tid, giltighetstiden för länken är 1 timma.'));
		} else {
			Flash.fromError(e);
		}

		router.push({ name: 'login' });
	})
;

const reset = () => {
	Flash.clear();

	if (password.value !== repeatPassword.value) {
		Flash.danger($gettext('Ditt nya lösenord stämde inte överens.'));

		return;
	}

	Loader.show();

	auth.passwordReset(selector, verifier, password.value)
		.then(() => {
			Flash.success($gettext('Ditt nya lösenord sparades!'));
			router.push({ name: 'login' });
		})
		.catch((e) => {
			handleFormError(e, errors);
		})
		.finally(() => Loader.hide())
	;
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(LoginLayout, {
    "page-title": _unref($gettext)('Återställning av lösenord')
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[2] || (_cache[2] = [
        _createTextVNode("Återställning av lösenord", -1)
      ]))])), [
        [_directive_translate]
      ]),
      _createElementVNode("form", {
        onSubmit: _withModifiers(reset, ["prevent"])
      }, [
        _createVNode(AppFormGroup, {
          id: "reset_password",
          label: _unref($gettext)('Nytt lösenord'),
          errors: errors.value.password
        }, {
          default: _withCtx(() => [
            _createVNode(AppInput, {
              type: "password",
              id: "reset_password",
              modelValue: password.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label", "errors"]),
        _createVNode(AppFormGroup, {
          id: "reset_repeat_password",
          label: _unref($gettext)('Repetera ditt nya lösenord')
        }, {
          default: _withCtx(() => [
            _createVNode(AppInput, {
              type: "password",
              id: "reset_repeat_password",
              modelValue: repeatPassword.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((repeatPassword).value = $event)),
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(AppButton, {
          type: "submit",
          class: "button-block"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Spara lösenordet", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 32),
      _createElementVNode("p", null, [
        _createVNode(_component_RouterLink, { to: {name: 'login'} }, {
          default: _withCtx(() => [
            _createVNode(FaIcon, { icon: "arrow-left" }),
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Gå tillbaka", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})